import {Link} from 'react-router-dom'
import {AiFillStar} from 'react-icons/ai'
import {MdLocationOn} from 'react-icons/md'
import {FaToolbox} from 'react-icons/fa'
import './index.css'

const DisplayJobs = props => {
  const {jobDetails} = props
  const {
    companyLogoUrl,
    employmentType,
    title,
    id,
    packagePerAnnum,
    rating,
    jobDescription,
    location,
  } = jobDetails

  return (
    <Link to={`/jobs/${id}`} className="Link">
      <li className="jobs-list-item">
        <div className="top-container">
          <img
            className="company-logo"
            src={companyLogoUrl}
            alt="company logo"
          />
          <div className="title-card">
            <h1 className="title">{title}</h1>
            <div className="rating-card">
              <AiFillStar color="#fbbf24" height="20" width="20" />
              <p className="rating">{rating}</p>
            </div>
          </div>
        </div>
        <div className="middle-container">
          <div className="middle-card">
            <MdLocationOn color="#ffffff" height="20" width="20" />
            <p className="location">{location}</p>
            <FaToolbox color="#ffffff" height="20" width="20" />
            <p className="type-of-employment">{employmentType}</p>
          </div>
          <p className="package">{packagePerAnnum}</p>
        </div>
        <hr className="horizontal-line" />
        <h1 className="description">Description</h1>
        <p className="job-description">{jobDescription}</p>
      </li>
    </Link>
  )
}
export default DisplayJobs
